import { render, staticRenderFns } from "./LogPage.vue?vue&type=template&id=6590b1ea&scoped=true&"
import script from "./LogPage.vue?vue&type=script&lang=js&"
export * from "./LogPage.vue?vue&type=script&lang=js&"
import style0 from "./LogPage.vue?vue&type=style&index=0&id=6590b1ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6590b1ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6590b1ea')) {
      api.createRecord('6590b1ea', component.options)
    } else {
      api.reload('6590b1ea', component.options)
    }
    module.hot.accept("./LogPage.vue?vue&type=template&id=6590b1ea&scoped=true&", function () {
      api.rerender('6590b1ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/setting/LogPage.vue"
export default component.exports